import LookupSiHaDocumentationStatusRequestModelBase from '../_generated/modelBases/lookup-si-ha-documentation-status-request-model-base';

export default class LookupSiHaDocumentationStatusRequestModel extends LookupSiHaDocumentationStatusRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
